import { TimelineParty } from '../slices/marketplace/timeline/models/enums/timeline-party.enum';

export const canMarkDataRequestItemsAsSeen = (
    party: TimelineParty
): boolean =>
    party === TimelineParty.Seller ||
    party === TimelineParty.SellerAndBuyer ||
    party === TimelineParty.VetValue;
